/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Payload du bloc « INFORMATIONS SUR LE DÉCÈS » : date et heure du décès,
 * envoyé via `service.update` (PUT `/numerisation-actes/deces/{identifiant}`).
 *
 * ⚠️ Deux choses n'y sont PAS, bien que `ec_actd` les porte : le LIEU du décès,
 * qui vit sur l'individu défunt (`PUT /acte-individus/{id}`, enchaîné par
 * `ModalEvenementDeces`), et la situation matrimoniale, qui a son propre
 * builder.
 *
 * @param identifiant Identifiant de l'ACTE : construit l'URL du PUT.
 * @param data État du formulaire de la modale.
 */
const buildEvenementDecesUpdatePayload = (
  identifiant: number,
  data: Record<string, any>,
) => ({
  identifiant,
  acte: {
    identifiant,
    dateDeces: data?.dateDeces,
    heureDeces: data?.heureDeces,
    minuteDeces: data?.minuteDeces,
  },
});

export default buildEvenementDecesUpdatePayload;
